<template>
<div>
  <BreadCrumb :data="breadCrumb" v-if="isBreadCrumb" />
  <div class="fault-support-tracking" :style="isBreadCrumb ? 'height:calc(73vh);align-items:unset': null">
    <b-card :style="isBreadCrumb ? 'height:calc(100vh - 10.3rem)': null">
      <FaultSupportTrackingForm />
      <b-spinner variant='primary' v-if="isLoading" class="mx-auto mt-4"></b-spinner>
      <div class="tracking-main" v-if="Object.keys(fault).length && !isLoading">
        <div class="tracking-info-main">
          <div class="tracking-info tracking-number">
            <h4>{{$t('stock.fault.no')}}</h4>
            <p class="tracking-no"><span>{{fault.fault_support_no}}</span></p>
          </div>
          <div class="tracking-info">
            <p class="tracking-title"><strong>{{$t('stock.fault.customer')}}</strong></p>
            <p class="tracking-info">{{fault.customer.name}}</p>
          </div>

          <div class="tracking-info">
            <p class="tracking-title"><strong>{{$t('stock.fault.product')}}</strong></p>
            <p class="tracking-info"> {{fault.product_serial_number}} - {{fault.product.name}}</p>
          </div>

          <div class="tracking-info">
            <p class="tracking-title"><strong>Sorun</strong></p>
            <p class="tracking-info">{{fault.problem}}</p>
          </div>
        <div class="_logo">
          <img src="https://sanatteknoloji.com.tr/yardim/img/sanat.png" class="logo" alt="Sanat Teknoloji">
        </div>
        </div>
        <div class="fs-info">
          <h4>{{$t('stock.fault.fMovements')}}</h4>
          <div class='steps' id='steps'>
            <div class="step" v-for="mv in movements" :key="mv.id">
              <div :class="'number completed '+mv.status.variant"> <b-icon :icon="mv.status.icon" /> </div>
              <div class='info'>
                <p class='title'> {{ mv.status.name }} </p>
                <p class='text'> {{ mv.description }}</p>
                <p class='text'> {{ dateFormat(mv.created_at)}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-card>
  </div>
</div>
</template>

<script>
import FaultSupportTrackingForm from './components/FaultSupportTrackingForm'
import MovementCard from './components/MovementCard'
import moment from "moment";
import BreadCrumb from "@/components/BreadCrumb";
import i18n from '@/plugins/i18n'

let breadCrumb = [
  { label: i18n.t('pages.stock.stocks'), url: "/Stock/List" },
  { label: i18n.t('pages.stock.fTracking'), url: "/Stock/FaultSupportTracking" },
  ];


export default {
  name: 'FaultSupportTracking',
  components: { FaultSupportTrackingForm, MovementCard, BreadCrumb },
  props: {
    isBreadCrumb: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return { 
      breadCrumb,
    }
  },
  computed: {
    isLoading() {
      return this.$store.getters.getStockLoading
    },
    fault() {
      return this.$store.getters.faultTracking
    },
    movements() {
      return this.fault.movements
    },
   
    value() {
      return this.movements.length
    },
    isClosed() {
      return this.movements.find(movement => movement.status.id == 5)
    },
    max() {
      return this.isClosed ? this.value : this.movements.length + 2
    }
  },
  methods:{
    dateFormat(data){
      return moment(String(data)).format('DD.MM.YYYY') 
    },
  }
}
</script>

<style scoped>
  @import "./styles/fsTracking.min.css";
</style>


// WEBPACK FOOTER //
// src/pages/ERP/Stock/FaultSupportsTracking.vue